import { render, staticRenderFns } from "./NoticeOther.vue?vue&type=template&id=1511a8b7"
import script from "./NoticeOther.vue?vue&type=script&lang=js"
export * from "./NoticeOther.vue?vue&type=script&lang=js"
import style0 from "./NoticeOther.vue?vue&type=style&index=0&id=1511a8b7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports